import { Modal } from 'antd';
import { useContext, useEffect } from 'react';
import WalletConnectButton from './components/providers/walletconnectbutton';
import MetamaskButton from './components/providers/metamaskbutton';
import { truncateAddress, truncateBalance } from './utils'
import ConnectedContext from './context/connectedcontext'
import ModalVisibilityContext from './context/modalvisiblitycontext';
import WalletExtensionButton from './components/providers/walletextensionbutton';
import './index.css'
import "antd/dist/antd.css";
import ScreenWidthContext from './context/screenwidthcontext';
import Web3Context from './context/web3context';
import Web3 from 'web3';
import Web3ContractReadWriteContext from './context/web3ContractReadWriteContext';
import { getScratchBalance } from './components/utils/scratch-functions';
import { webStorage } from './config';


function ConnectModal() {

    // Get web3 and the account (metamask public key) to place it on our button text once user is CONNECTED
    const { account, setAccount, balance, setBalance, chainID, setChainID, scratchBalance, setScratchBalance } = useContext(Web3Context) //ommiting web3 and creating it locally because of having to set up contract
    // context to verify if the user WANTS to be connected ot the site, IE if they have clicked the connect button yet, again we cant DISCONNECT the user's metamask, only give the illusion of NOT being connected
    const { connected, setConnected } = useContext(ConnectedContext)
    // Screen Width context
    const { screenWidth } = useContext(ScreenWidthContext)
    // contract read and write providers context
    const { setContractReadProviders, setContractWriteProviders } = useContext(Web3ContractReadWriteContext)
    //set up for Modal Visibility Context
    const { modalVisibility, setModalVisibility } = useContext(ModalVisibilityContext)

    //toggles visibility of modal, called when clicking on "Connect Wallet" button and used when hitting "Close" in the modal or pressing anywhere in the "mask area" aka grey area of modal  
    const toggleVisibility = () => {
        setModalVisibility(!modalVisibility)
    }

    //On clicking disconnect in the modal brought up by clicking on the wallet button while user is connected using metamask
    const disconnect = () => {
        localStorage.clear();
        setConnected(false)
        setModalVisibility(false)
    }

    //persist metamask connection in local storage
    useEffect(() => {
        function connect() {
            //initialize web3
            const web3temp = new Web3(Web3.givenProvider || "ws://localhost:8545");
            //ask for access from metamask
            web3temp.eth.requestAccounts().then(function (accounts) {
                const account = accounts[0]
                setContractReadProviders(Web3.givenProvider || "https://mmf-rpc.xstaking.sg/" || "ws://localhost:8545")
                setContractWriteProviders(Web3.givenProvider || "ws://localhost:8545")
                setAccount(account)
                web3temp.eth.getBalance(account, function (err, result) {
                    if (err) {
                        console.log(err)
                    } else {
                        console.log(web3temp.utils.fromWei(result, "ether") + " ETH")
                        setBalance(web3temp.utils.fromWei(result, "ether"))
                    }
                })
                getScratchBalance((Web3.givenProvider || "https://mmf-rpc.xstaking.sg/" || "ws://localhost:8545"), account).then(function (scratchResult) {
                    setScratchBalance(scratchResult as string)
                })
                web3temp.eth.getChainId().then(function (result: any) {
                    setChainID(result)
                    console.log(result)
                })

            }).then(function () {
                setConnected(true)
                localStorage.setItem('isWalletConnected', 'true')
            });
        }

        const connectWalletOnPageLoad = async () => {
            if (localStorage?.getItem('isWalletConnected') === 'true') {
                connect()
            }
        }
        connectWalletOnPageLoad()
    }, [setAccount, setBalance, setChainID, setConnected, setContractReadProviders, setContractWriteProviders, setScratchBalance])

    const isDesktop = screenWidth > 1279
    const isSupportedChain = chainID === 25 || chainID === 338 || chainID === 1337

    const triggerClasses = !connected
        ? `inline-flex items-center justify-center rounded-full border border-[#59d6ff]/35 bg-[#59d6ff]/10 font-semibold uppercase tracking-[0.18em] text-[#e8fbff] transition hover:bg-[#59d6ff]/18 ${isDesktop ? 'px-4 py-2.5 text-[12px]' : 'px-3 py-2 text-[11px]'}`
        : isSupportedChain
            ? `inline-flex items-center rounded-full border border-white/10 bg-white/5 text-[#f6efd3] transition hover:border-white/20 hover:bg-white/10 ${isDesktop ? 'gap-1.5 p-1 pr-1.5' : 'gap-2 px-3 py-2'}`
            : `inline-flex items-center justify-center rounded-full border border-[#ff8a72]/35 bg-[#ff8a72]/12 font-semibold uppercase tracking-[0.18em] text-[#ffe1da] transition hover:bg-[#ff8a72]/18 ${isDesktop ? 'px-4 py-2.5 text-[12px]' : 'px-3 py-2 text-[11px]'}`

    const renderTrigger = () => {
        if (!connected) {
            return (
                <button type="button" className={triggerClasses} onClick={toggleVisibility}>
                    {isDesktop ? 'Connect Wallet' : 'Wallet'}
                </button>
            );
        }

        if (isSupportedChain) {
            return (
                <button type="button" className={triggerClasses} onClick={toggleVisibility}>
                    {isDesktop ? (
                        <>
                            <span className="flex items-center gap-1 rounded-full bg-black/20 px-2.5 py-1.5 text-[10px] uppercase tracking-[0.16em] text-[#d9e3ee]">
                                <img
                                    className="h-3.5 w-3.5 object-contain"
                                    src={webStorage + '/navbar/cronosLogoHR.png'}
                                    alt="Cronos"
                                />
                                {truncateBalance(balance, 2)}
                            </span>
                            <span className="flex items-center gap-1 rounded-full bg-black/20 px-2.5 py-1.5 text-[10px] uppercase tracking-[0.16em] text-[#dfffd2]">
                                <img
                                    className="h-3.5 w-3.5 object-contain"
                                    src={webStorage + '/boomrooms/SCRATCH.svg'}
                                    alt="SCRATCH"
                                />
                                {truncateBalance(scratchBalance, 2)}
                            </span>
                            <span className="rounded-full border border-[#59d6ff]/30 bg-[#59d6ff]/14 px-3 py-1.5 text-[13px] font-semibold tracking-[0.06em] text-[#f2fbff]">
                                {truncateAddress(account, 2)}
                            </span>
                        </>
                    ) : (
                        <>
                            <span className="h-2.5 w-2.5 rounded-full bg-[#9cff74]" />
                            <span className="font-brand text-xs uppercase tracking-[0.08em] text-[#f2fbff]">
                                {truncateAddress(account, 2)}
                            </span>
                        </>
                    )}
                </button>
            );
        }

        return (
            <button type="button" className={triggerClasses} onClick={toggleVisibility}>
                Wrong Network
            </button>
        );
    };

    //Use logic to determine which button to show: Either the connect wallet button or the user's metamask public key if the user is already connected
    return (
        <>
            {renderTrigger()}
            <Modal
                centered
                visible={modalVisibility}
                footer={null}
                width={isDesktop ? 420 : Math.min(340, screenWidth - 24)}
                onCancel={toggleVisibility}
                closable={false}
                transitionName=""
                className="boomer-connect-modal"
                bodyStyle={{ padding: 0 }}
            >
                <div className="rounded-[28px] border border-white/10 bg-[#08111b] p-5 shadow-boomer sm:p-6">
                    <div className="flex items-start justify-between gap-4">
                        <div className="flex items-center gap-3">
                            <div className="flex h-14 w-14 items-center justify-center rounded-[20px] bg-[#fff2cc]">
                                <img
                                    src={webStorage + '/navbar/boomersquadlogo2.png'}
                                    alt="Boomer Squad"
                                    className="h-10 w-10 object-contain"
                                />
                            </div>
                            <div>
                                <div className="text-[11px] uppercase tracking-[0.28em] text-[#59d6ff]">
                                    Wallet
                                </div>
                                <div className="font-brand text-2xl uppercase tracking-[0.08em] text-[#fff2cc]">
                                    {!connected ? 'Connect' : isSupportedChain ? 'Connected' : 'Wrong Network'}
                                </div>
                            </div>
                        </div>
                        <button
                            type="button"
                            onClick={toggleVisibility}
                            aria-label="Close wallet modal"
                            className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-white/5 text-2xl text-[#d9e3ee]"
                        >
                            ×
                        </button>
                    </div>

                    {!connected ? (
                        <>
                            <p className="mt-5 text-sm leading-7 text-[#c7d2de]">
                                Connect with your preferred wallet to access Mattress Fund actions, collection pages, and the rest of the live Boomer Squad features.
                            </p>
                            <div className="mt-5 space-y-3">
                                <MetamaskButton />
                                <WalletExtensionButton />
                                <WalletConnectButton />
                            </div>
                        </>
                    ) : isSupportedChain ? (
                        <>
                            <div className="mt-5 rounded-[24px] border border-white/10 bg-white/5 p-4">
                                <div className="text-[11px] uppercase tracking-[0.28em] text-[#59d6ff]">
                                    Connected Address
                                </div>
                                <div className="mt-2 font-brand text-xl uppercase tracking-[0.08em] text-[#fff2cc]">
                                    {truncateAddress(account, 4)}
                                </div>
                                <div className="mt-2 break-all text-xs leading-6 text-[#aebdca]">
                                    {account}
                                </div>
                            </div>

                            <div className="mt-4 grid grid-cols-2 gap-3">
                                <div className="rounded-[20px] border border-white/10 bg-white/5 p-4">
                                    <div className="text-[11px] uppercase tracking-[0.24em] text-[#59d6ff]">
                                        CRO
                                    </div>
                                    <div className="mt-2 font-brand text-2xl uppercase tracking-[0.08em] text-[#fff2cc]">
                                        {truncateBalance(balance, 2)}
                                    </div>
                                </div>
                                <div className="rounded-[20px] border border-white/10 bg-white/5 p-4">
                                    <div className="text-[11px] uppercase tracking-[0.24em] text-[#9cff74]">
                                        SCRATCH
                                    </div>
                                    <div className="mt-2 font-brand text-2xl uppercase tracking-[0.08em] text-[#fff2cc]">
                                        {truncateBalance(scratchBalance, 2)}
                                    </div>
                                </div>
                            </div>

                            <button
                                type="button"
                                onClick={disconnect}
                                className="mt-5 inline-flex w-full items-center justify-center rounded-full border border-[#ff8a72]/35 bg-[#ff8a72]/12 px-5 py-3 text-sm font-semibold uppercase tracking-[0.18em] text-[#ffe1da] transition hover:bg-[#ff8a72]/18"
                            >
                                Disconnect
                            </button>
                        </>
                    ) : (
                        <>
                            <p className="mt-5 text-sm leading-7 text-[#c7d2de]">
                                Your wallet is connected, but it is not on a supported Cronos network. Switch networks in your wallet, or disconnect below.
                            </p>
                            <button
                                type="button"
                                onClick={disconnect}
                                className="mt-5 inline-flex w-full items-center justify-center rounded-full border border-[#ff8a72]/35 bg-[#ff8a72]/12 px-5 py-3 text-sm font-semibold uppercase tracking-[0.18em] text-[#ffe1da] transition hover:bg-[#ff8a72]/18"
                            >
                                Disconnect
                            </button>
                        </>
                    )}
                </div>
            </Modal>
        </>
    );
}

export default ConnectModal
